import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import MyClinic from './MyClinic'
import MyProfile from './MyProfile'
import ClinicWeekHours from './ClinicWeekHours'

import AppointmentTypes from './AppointmentTypes'
import Rooms from './Rooms'
import Users from './Users'
import Doctors from './Doctors'
import BookingPages from './BookingPages'
import Schedule from './Schedule'
import Reminders from './Reminders'
import Labels from './Labels'
import PatientDocuments from './PatientDocuments'
import Finance from './Finance'
import Reschedule from './Reschedule'

const Container = styled.div`
  min-height: 100vh;
  background-color: #f9fafb;
  overflow-y: auto;
  height: 100vh;
`

const Settings = () => {
  const location = useLocation()
  const [activeTab, setActiveTab] = useState('general')

  useEffect(() => {
    const pathParts = location.pathname.split('/')
    const settingsIndex = pathParts.indexOf('settings')
    const currentTab =
      settingsIndex >= 0 && pathParts[settingsIndex + 1]
        ? pathParts[settingsIndex + 1]
        : 'general'
    setActiveTab(currentTab)
  }, [location.pathname])

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'general':
        return <MyClinic />
      case 'profile':
        return <MyProfile />
      case 'scheduling':
        return <Schedule />
      case 'rooms':
        return <Rooms />
      case 'appointment-types':
        return <AppointmentTypes />
      case 'doctors':
        return <Doctors />
      case 'labels':
        return <Labels />
      case 'reminders':
        return <Reminders />
      case 'finance':
        return <Finance />
      case 'users':
        return <Users />
      case 'booking-pages':
        return <BookingPages />
      case 'reschedule':
        return <Reschedule />
      case 'patient-documents':
        return <PatientDocuments />
      case 'regular-hours':
        return <ClinicWeekHours />
      default:
        return <MyClinic />
    }
  }

  return <Container>{renderActiveTab()}</Container>
}

export default Settings
